import { Deserializable } from '../../../lib/models/deserializable';
import { ApplicationProductRepaymentMethod } from './application-product-repayment-method.model';
import { CaseProduct } from './case-product.model';

export class ApplicationProduct implements Deserializable {
  public ApplicationNumber?: number;
  public CaseProductID?: number;
  public ApplicationProductID: number;
  public AreRepaymentAssetsInSterlingCode: string;
  public RepaymentMonthlyCost?: number;
  public RepaymentMaturityDate?: Date;
  public RepaymentProjectedValue?: number;
  public CaseProduct: CaseProduct;
  public ApplicationProductRepaymentMethods: Array<ApplicationProductRepaymentMethod>;

  deserialize(input: any): this {
    Object.assign(this, input);
    this.CaseProduct = input.CaseProduct ? new CaseProduct().deserialize(input.CaseProduct) : new CaseProduct();

    this.ApplicationProductRepaymentMethods = input.ApplicationProductRepaymentMethods
      ? input.ApplicationProductRepaymentMethods.map((method) =>
          new ApplicationProductRepaymentMethod().deserialize(method)
        )
      : new Array<ApplicationProductRepaymentMethod>();

    return this;
  }
}
